module.exports = __webpack_public_path__ + "img/tiefox_title.b2f1280c.png";